'use strict';

(function ($) {
  var methods = {
    init: function (options) {
      // options are not used
      var opts = $.extend({}, $.fn.k2_checkboxesToggler.defaults, options);
      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('checkboxes-toggler-init')) {
          return;
        }

        $this.addClass('checkboxes-toggler-init');

        $this.on('click', function () {
          if ($this.is(':checked')) {
            opts.$container.find('input:checkbox:visible').not($this).prop('checked', true);
          } else {
            opts.$container.find('input:checkbox:visible').not($this).prop('checked', false);
          }
        });
      });
    }
  };

  $.fn.k2_checkboxesToggler = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_checkboxesToggler');
    }

  };

  $.fn.k2_checkboxesToggler.defaults = {
    $container: $('body')
  };

})(jQuery);
